export default [
  {
    name: 'getQuartzJob',
    method: 'GET',
    path: '/vue/quartz/quartzjob-get'
  },
  {
    name: 'getQuartzJobPage',
    method: 'POST',
    path: '/vue/quartz/quartzjob-page'
  },
  {
    name: 'saveQuartzJob',
    method: 'POST',
    path: '/vue/quartz/quartzjob-save'
  },
  {
    name: 'deleteQuartzJob',
    method: 'POST',
    path: '/vue/quartz/quartzjob-delete'
  },
  {
    name: 'addQuartzJob',
    method: 'POST',
    path: '/vue/quartz/quartzjob-add'
  },
  {
    name: 'editQuartzJob',
    method: 'POST',
    path: '/vue/quartz/quartzjob-edit'
  },
  {
    name: 'pauseQuartzJob',
    method: 'POST',
    path: '/vue/quartz/quartzjob-pause'
  },
  {
    name: 'resumeQuartzJob',
    method: 'POST',
    path: '/vue/quartz/quartzjob-resume'
  }
];
